import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-accessibility-statement',
  templateUrl: './accessibility-statement.component.html',
  styleUrls: ['./accessibility-statement.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccessibilityStatementComponent {

  constructor() {}

}